type TextCarouselLoaderTrackPoint = readonly [
	seconds: number,
	value: number | string
];

const PHRASE_EASE = [0.455, 0.03, 0.515, 0.955] as const;

const OPACITY_POINTS: readonly TextCarouselLoaderTrackPoint[] = [
	[0, 0],
	[0.8, 0.4],
	[1, 0.4],
	[1.6, 1],
	[4.2, 1],
	[5, 0]
];

const COLOR_POINTS: readonly TextCarouselLoaderTrackPoint[] = [
	[0, '#888'],
	[1, '#888'],
	[1.6, '#000'],
	[3.3, '#000'],
	[3.9, '#888']
];

const SCALE_POINTS: readonly TextCarouselLoaderTrackPoint[] = [
	[0, 1],
	[2, 1],
	[2.5, 1.1],
	[2.7, 1.1],
	[3.1, 1]
];

export {
	COLOR_POINTS,
	OPACITY_POINTS,
	PHRASE_EASE,
	SCALE_POINTS,
	type TextCarouselLoaderTrackPoint
};
